import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import NoRoute from './pages/NoRouteFound';
import NewLandingPage from './pages/new-landing-page';
import GtenHome from './components/gten-home/GtenHome';

const sectionPaths = ['approach', 'capabilities', 'stories', 'gainss', 'about', 'contact'];

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GtenHome />} />
        {sectionPaths.map((path) => (
          <Route key={path} path={`/${path}`} element={<GtenHome />} />
        ))}
        <Route path="/new-landing-page" element={<NewLandingPage />} />
        <Route path="*" element={<NoRoute />} />
      </Routes>
    </BrowserRouter >
  );
}

export default Router;